import { FindingState } from "@oneleet/api_client";
import { classNames } from "@oneleet/utils/src/utils";

type Props = {
  state: FindingState;
  onClick?: () => void;
};

export default function Status(props: Props) {
  let indicatorColor;
  let text;

  switch (props.state) {
    case FindingState.DRAFT:
      indicatorColor = "bg-gray-800";
      text = "Draft";
      break;
    case FindingState.OPEN:
      indicatorColor = "bg-red-600";
      text = "Open";
      break;
    case FindingState.IN_REVIEW:
      indicatorColor = "bg-yellow-500";
      text = "In Review";
      break;
    case FindingState.REMEDIATED:
      indicatorColor = "bg-green-500";
      text = "Remediated";
      break;
    case FindingState.DUPLICATE:
      indicatorColor = "bg-green-500";
      text = "Duplicate";
      break;
    case FindingState.REJECTED:
      indicatorColor = "bg-green-500";
      text = "Rejected";
      break;
    case FindingState.FALSE_POSITIVE:
      indicatorColor = "bg-green-500";
      text = "False Positive";
      break;
    case FindingState.ACCEPTED_RISK:
      indicatorColor = "bg-blue-500";
      text = "Accepted Risk";
      break;
    default:
      indicatorColor = "bg-yellow-500";
      text = "Unknown";
      break;
  }

  return (
    <div className={`flex flex-row items-center gap-2 whitespace-nowrap`}>
      <div className={classNames("h-2 w-2 rounded-full", indicatorColor)}></div>
      <span className="text-sm font-semibold text-gray-700">{text}</span>
    </div>
  );
}
